import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div data-testid="blog-page">
      <SEO
        title="Seafood Blog · Recipes, Techniques, Sustainability"
        description="Chef-written articles on cooking fish, smoking techniques, sustainable sourcing, and seasonal seafood inspiration."
        path="/blog"
      />
      <section className="bg-[color:var(--color-primary)] text-white py-20">
        <div className="container-x px-6">
          <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--color-accent)] mb-4">From the Kitchen</div>
          <h1 className="font-display text-5xl md:text-6xl">Blog & Recipes</h1>
        </div>
      </section>
      <section className="section bg-[color:var(--color-bg)]">
        <div className="container-x">
          {posts.length === 0 ? (
            <div className="text-center py-16 text-[color:var(--color-text-secondary)]" data-testid="no-blog">No articles yet. Check back soon.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p) => (
                <Link key={p.id} to={`/blog/${p.slug}`} className="product-card block bg-white border border-[color:var(--color-border)] rounded-lg overflow-hidden" data-testid={`blog-card-${p.slug}`}>
                  <div className="aspect-[16/10] bg-gray-100 overflow-hidden">
                    {p.featured_image && <img src={p.featured_image} alt={p.title} className="w-full h-full object-cover" />}
                  </div>
                  <div className="p-6">
                    <div className="text-xs uppercase tracking-widest text-[color:var(--color-accent)] mb-2">{p.category}</div>
                    <h3 className="font-display text-2xl text-[color:var(--color-primary)] mb-2">{p.title}</h3>
                    <p className="text-sm text-[color:var(--color-text-secondary)] line-clamp-3">{p.excerpt}</p>
                    <div className="mt-4 text-xs uppercase tracking-widest text-[color:var(--color-primary)]">Read More →</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
